import React, { useState } from 'react';
import { Box, Typography, Button, IconButton, Link } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons';
import COLORS from '../../../../constants/colors'; // Import colors
import Bars_icon_light from '../../../../assets/icons/side.svg'; // Adjust the path to your SVG file
import logo from "../../../../assets/logo.png"; // Import your logo


const Header = ({ mode }) => {
  const [drawerOpen, setDrawerOpen] = useState(false); // Manage side nav drawer state

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const headerLinkStyle = {
    color: COLORS.primary, // Change link color based on mode
    fontSize: '16px',
    border: 'none',
    textDecoration: 'none',
    margin: '0 30px',
    textTransform: 'none',
    fontWeight: '500',
    position: 'relative',
    transition: 'all 0.3s ease-in-out',
    '&:after': {
      content: '""',
      position: 'absolute',
      width: '100%',
      height: '4px',
      backgroundColor: COLORS.primary,
      bottom: '-6px',
      left: '0',
      transform: 'scaleX(0)',
      transformOrigin: 'bottom right',
      transition: 'transform 0.5s ease-out',
    },
    '&:hover:after': {
      transform: 'scaleX(1)',
      transformOrigin: 'bottom left',
    },
  };

  return (
    <>
      {/* Header */}
      <Box
        sx={{
          backgroundColor: COLORS.white,
          backdropFilter: 'blur(20px)',
          WebkitBackdropFilter: 'blur(10px)',
          color: 'text.primary',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '15px 20px',
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          paddingY: 2,
          pt: 2,
          paddingX: { xs: 2, sm: 4, md: 8 },
          flexDirection: { xs: 'row', sm: 'row' },
        }}
      >
        {/* Left Section: Logo Image */}
<Box sx={{ display: 'flex', alignItems: 'center' }}>
  <Box
    component="img"
    src={logo}
    alt="Yamba Logo"
    sx={{
      height: 40, // Adjust height as needed
      width: 'auto',
      objectFit: 'contain',
      cursor: 'pointer',
    }}
  />
</Box>

        

       
      </Box>

    </>
  );
};

export default Header;
